import React from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import classNames from 'classnames';
import scrollToComponent from 'react-scroll-to-component';

import TagManager from "../../TagManager";
import {t} from "../../Translations";
import Annotation from "../widgets/Annotation";
import Radio from "../widgets/Radio";
import StepSubTitle from "../widgets/StepSubTitle";
import Label from "../widgets/Label";
import { mapSizesToProps } from '../../utils';
import Configuration from "../../Configuration";

class Step2_4 extends React.Component {

    static propTypes = {
        className: PropTypes.string,

        // Triggered when step data change
        onDataChange: PropTypes.func,

        // Used to initialize step data
        data: PropTypes.shape({
            drivingSpeed: PropTypes.number,
            drivingBehaviour: PropTypes.number
        })
    };

    static defaultProps = {
        data: {
            drivingSpeed: undefined,
            drivingBehaviour: undefined
        }
    };

    choicesQuestion1 = [
        {label: t('Step2_driving_question_1_answer1'), value: 1},
        {label: t('Step2_driving_question_1_answer2'), value: 2},
        {label: t('Step2_driving_question_1_answer3'), value: 3},
        {label: t('Step2_driving_question_1_answer4'), value: 4},
        {label: t('Step2_driving_question_1_answer5'), value: 5}
    ];

    choicesQuestion2 = [
        {label: t('Step2_driving_question_2_answer1'), value: 1},
        {label: t('Step2_driving_question_2_answer2'), value: 2},
        {label: t('Step2_driving_question_2_answer3'), value: 3},
        {label: t('Step2_driving_question_2_answer4'), value: 4},
        {label: t('Step2_driving_question_2_answer5'), value: 5}
    ];

    /**
     * References to DOM node of Radios components
     */
    radioRefs = [];

    componentDidMount() {
        const {data, vehicleDetail} = this.props

        TagManager.sendEvent(
            '/consommation/form/estimation-precise-usage/step-4',
            'form page',
            null,
            'consommation estimation precise',
            4,
            'conduite',
            data.bodyStyle,
            `${vehicleDetail.model} ${vehicleDetail.bodyStyle} ${vehicleDetail.commercialName} ${vehicleDetail.engine}`
        )
    }

    onChange = (dataKey, index) => value => {
        // Scroll to next Radio
        const nextRefIndex = index < this.radioRefs.length - 1 ? (index + 1) : index
        
        scrollToComponent(this.radioRefs[nextRefIndex], {
            duration: 500
        })

        this.props.onDataChange && this.props.onDataChange(dataKey)(value);
    }

    render() {
        const {className, data, width} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        const buttonClass = "cccu-step4 button-step-4-"+client;
        const labelStep4 = "cccu-step4 label-step-4-"+client;
        const classes = classNames(
          "container-form-step2",
          "p-4",
            {
                [className]: className !== undefined
            }
        );

        return (
            <section className={classes}>
                <StepSubTitle className="my-2">
                    {t('Step2_driving_label')}
                </StepSubTitle>

                <div className="row radio-column">
                    {width >= 992 && (
                        <React.Fragment>
                            <div className="radio-label col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <Label labelStep4={labelStep4}>{t('Step2_driving_question_1')}<sup>(1)</sup></Label>
                            </div>

                            <div className="radio-label col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <Label labelStep4={labelStep4}>{t('Step2_driving_question_2')}<sup>(1)</sup></Label>
                            </div>
                        </React.Fragment>
                    )}
                    
                    <Radio
                        ref={radio => this.radioRefs[0] = radio}
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                        label={width < 992 ? t('Step2_driving_question_1') : undefined}
                        data={this.choicesQuestion1}
                        value={data.drivingSpeed}
                        buttonClass={buttonClass}
                        onChange={this.onChange('drivingSpeed', 0)}
                    />

                    <Radio
                        ref={radio => this.radioRefs[1] = radio}
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                        label={width < 992 ? t('Step2_driving_question_2') : undefined}
                        data={this.choicesQuestion2}
                        value={data.drivingBehaviour}
                        buttonClass={buttonClass}
                        onChange={this.onChange('drivingBehaviour', 1)}
                    />

                    <div className="annotation-container col-12 ">
                        <Annotation>
                            {t('Step2_driving_legal')}
                        </Annotation>
                    </div>
                </div>
            </section>
        )
    }
}

export default withSizes(mapSizesToProps)(Step2_4);


// WEBPACK FOOTER //
// ./src/components/steps/Step2_4.js